import React from 'react';

const EdgeBlocks = ({ 
  width = 50, 
  height = 12, 
  className = "",
  style = {} 
}) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 34 8" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={{ verticalAlign: 'middle', ...style }}
  >
    <rect x="0" y="0" width="8" height="8" rx="2" fill="#2ecc71"/>
    <rect x="11" y="0" width="8" height="8" rx="2" fill="#f39c12"/>
    <rect x="22" y="0" width="8" height="8" rx="2" fill="#3498db"/>
  </svg>
);

export default EdgeBlocks;